
    import { adapter, enhanceGlobals } from 'next/dist/esm/server/web/adapter'
    import { getHandle } from 'next/dist/esm/build/webpack/loaders/next-edge-app-route-loader/handle'

    enhanceGlobals()

    import * as mod from "next-app-loader?name=app%2Fapi%2Fchat%2Froute&pagePath=private-next-app-dir%2Fapi%2Fchat%2Froute.ts&appDir=%2FUsers%2Fxcatliu%2Fwork%2Fgithub%2Fchatgpt-next%2Fapp&appPaths=%2Fapi%2Fchat%2Froute&pageExtensions=tsx&pageExtensions=ts&pageExtensions=jsx&pageExtensions=js&assetPrefix=!private-next-app-dir/api/chat/route.ts?__edge_ssr_entry__"

    const render = getHandle({
      mod,
      page: "/api/chat/route",
    })

    export const ComponentMod = mod

    export default function(opts) {
      return adapter({
        ...opts,
        handler: render
      })
    }